'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.authenticate = authenticate;
exports.logout = logout;

var _authClient = require('@getgo/auth-client');

var _authClient2 = _interopRequireDefault(_authClient);

var _config = require('../../../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* flow */

// Libraries
var configuration = void 0;

/**
 * Performs authentication for a token type based on the configuration provided in the Config file.
 *
 * @param tokenReadyCallback
 */
function authenticate(pathname, termsOfServiceAccepted, tokenReadyCallback) {
    var settings = config().oauth;

    if (config().oauth.enabled) {
        settings.state = {
            pathname: pathname,
            termsOfServiceAccepted: termsOfServiceAccepted
        };
        var auth = new _authClient2.default(settings);
        var token = auth.init();

        if (token) {
            try {
                sessionStorage.setItem('accessToken', token.access_token);
            } catch (e) {
                console.log('error', e);
            }
            tokenReadyCallback(token);
        } else {
            auth.login();
        }
    } else {
        tokenReadyCallback();
    }
}

function logout() {
    try {
        localStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('userSessionId');
    } catch (e) {
        console.log('error', e);
    }

    var settings = config().oauth;
    var auth = new _authClient2.default(settings);
    auth.logout();
}

function config() {
    if (!configuration) {
        configuration = _config.Configuration.getConfig();
    }

    return configuration;
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/web/lib/app/Authenticator.js
// module id = 730
// module chunks = 0